import request from "@/utils/request.js";

/**
 * 获取个人主页面
 * @param params
 * @returns {AxiosPromise}
 */
export function getHomePage(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/getHomePage",
    method: "post",
    data: params
  });
}

/**
 * 退出
 * @param params
 * @returns {AxiosPromise}
 */
export function logout(params) {
  return request({
    url: "/userService/api/app/userNurse/logout",
    method: "post",
    data: params
  });
}

/**
 *
 * /qiyu/user/getNurseUserUid
 * 护士用户uid
 * @param params
 * @returns {AxiosPromise}
 */
export function getNurseUserUid(params) {
  return request({
    url: "/operateService/api/user/md5/getNurseUserUid",
    method: "post",
    data: params
  });
}
